export default __webpack_public_path__ + "static/media/Gilroy-Regular.5b89a8df.ttf";